import './index.css';
import { Col, Container, Row } from 'react-bootstrap';

const ProjectDescHead = (props) => {
  return (
    <div className="container-bg-desc">
      <Container>
        <Row className="pt-5">
          <Col md={{ span: 12 }}>
            <div className="d-flex flex-column justify-content-start">
              <div className="title-head">{props.name}.</div>
              <hr align="left" className="hr-style" />
              <div className="">Category: {props.category}</div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ProjectDescHead;
